/**
 * Display Location Control Component
 * 
 * @package TopBuddy
 */

import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const DisplayLocationControl = ({ value, onChange }) => {
	return (
		<div className="topbuddy-display-rules__field">
			<SelectControl
				label={__('Display Location', 'topbuddy')}
				help={__('Choose where this notification bar should appear', 'topbuddy')}
				value={value}
				onChange={onChange}
				options={[
					{ label: __('Everywhere', 'topbuddy'), value: 'everywhere' },
					{ label: __('General Pages', 'topbuddy'), value: 'general_pages' },
					{ label: __('Specific Pages', 'topbuddy'), value: 'specific_pages' },
				]}
				__next40pxDefaultSize
				__nextHasNoMarginBottom
			/>
		</div>
	);
};

export default DisplayLocationControl;
